export default "__VITE_ASSET__DXLLJdX0__"